import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../../Base';
import { Header } from '../../Header';
import { Footer } from '../../Footer';
import Curriculum from "../Curriculum/Curriculum";
import CurriculumTypes from '../CurriculumType/CurriculumTypes';
import CurriculumLevels from '../CurriculumLevel/CurriculumLevels';
import CurriculumSessions from '../CurriculumSession/CurriculumSessions';
import CurriculumPersons from '../CurriculumPerson/CurriculumPersons';
import Movements from '../Movement/Movements';

export default class Curriculums extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'curriculum',
            data: null,
            loading: true,
            page: 1,
            per_page: 30,
            phrase: '',
            menuId: 208
        };
        this.state.filters = {
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Curriculum Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Curriculum Caller={this} /> });
    }
    curriculumTypes() {
        this.removeKeyDown();
        this.showComponents({ component: <CurriculumTypes Caller={this} /> });
    }
    curriculumLevels() {
        this.removeKeyDown();
        this.showComponents({ component: <CurriculumLevels Caller={this} /> });
    }
    curriculumSessions(curriculumId) {
        this.removeKeyDown();
        this.showComponents({ component: <CurriculumSessions Caller={this} CurriculumId={curriculumId} /> });
    }
    curriculumPersons(curriculumId) {
        this.removeKeyDown();
        this.showComponents({ component: <CurriculumPersons Caller={this} CurriculumId={curriculumId} /> });
    }
    movements() {
        this.removeKeyDown();
        this.showComponents({ component: <Movements Caller={this} /> });
    }    
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست برنامه های آموزشی</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} برنامه یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><span className="shortcut">F2 - </span><span>ایجاد برنامه جدید</span></a>
                                        </li>
                                        <li>
                                            <a onClick={e => this.movements()} className="hand btn btn-success">حرکات</a>
                                        </li>
                                        <li>
                                            <a onClick={e => this.curriculumTypes()} className="hand btn btn-success">انواع برنامه ها</a>
                                        </li>
                                        <li>
                                            <a onClick={e => this.curriculumLevels()} className="hand btn btn-success">سطوح برنامه ها</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="عنوان برنامه" className="form-control" />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ برنام های یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">کد</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شخص</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">عنوان</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">نوع</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">سطح</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">فعال است</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">کد: </span>
                                                    <span className="sub-text text-center"><a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                        {record.code}
                                                    </a>
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">شخص: </span>
                                                    <span className="sub-text text-center">{record.personName}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">عنوان: </span>
                                                    <span className="sub-text text-center">{record.title}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">نوع: </span>
                                                    <span className="sub-text text-center">{record.curriculumTypeTitle}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">سطح: </span>
                                                    <span className="sub-text text-center">{record.curriculumLevelTitle}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">فعال است: </span>
                                                    <span className="sub-text text-center">{record.isActive ? "بله" : "خیر"}</span>
                                                </div>
                                                <div className="nk-tb-col text-end">
                                                    <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                        {/*<em className="icon ni ni-cross-fill-c"></em>*/}
                                                        حذف
                                                    </a>
                                                    <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                        {/*<em className="icon ni ni-pen"></em>*/}
                                                        ویرایش
                                                    </a>
                                                    {1 == 2 && <a className="hand text-success mx-1" onClick={e => this.curriculumSessions(record.id)} title="جلسات">
                                                        {/*<em className="icon ni ni-chat-circle"></em>*/}
                                                        جلسات
                                                    </a>}
                                                    {1 == 2 && <a className="hand text-success mx-1" onClick={e => this.curriculumPersons(record.id)} title="فراگیران">
                                                        فراگیران
                                                    </a>}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                ,
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}